import axios from "axios";
import {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function InvResultEntry(props) {
    const {appt_id, itest_id} = useParams();
    const [invData, setinvData] = useState([]);
    const [investDataMap, setInvestDataMap] = useState({});
    const [files, setFiles] = useState('');
    const [remarks, setRemarks] = useState("");
    const [temp, setTemp] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [resultFormData, setResultFormData] = useState({
        "appt_id": '',
        "pat": '',
        "itest_id": '',
        "invt_files": '',
        "remarks": '',
    });
    useEffect(() => {
        try {
            axios.get(baseUrl + 'inv-test/' + appt_id + '/')
                .then((response3) => {
                    const index = response3.data[0].itest_id.split(',').indexOf(itest_id);
                    const pat_id = response3.data[0].pat.id;
                    const patient = response3.data[0].pat.patient;
                    const cons = response3.data[0].cons.consultant;
                    if (index !== -1) {
                        const inv_test = response3.data[0].inv_test.split(',')[index];
                        setinvData([{
                            itest_id: itest_id,
                            inv_test: inv_test,
                            pat_id: pat_id,
                            patient: patient,
                            cons: cons,
                        }]);
                    }
                });
        } catch (error) {
            console.log("Error:", error);
        }
    }, [appt_id, itest_id]);
    useEffect(() => {
        axios
            .get(`${baseUrl}template-create/`)
            .then((response) => setTemp(response.data))
            .catch((error) => console.log(error));
    }, []);
    // Handle template select
    const handleTemplateChange = (event) => {
        const selectedTemplateId = event.target.value;
        setSelectedTemplate(selectedTemplateId);
        axios
            .get(baseUrl + "edit-template/" + selectedTemplateId + "/")
            .then((response) => setRemarks(response.data.template || ""))
            .catch((error) => console.log(error));
    };
    const handleChange = (event) => {
        setResultFormData({
            ...resultFormData,
            [event.target.name]: event.target.value
        });
    }
    const handleFileChange = (event) => {
        const {name, files} = event.target;
        setResultFormData({
            ...resultFormData,
            [name]: files,
        });
    };
    const formSubmit = (e) => {
        e.preventDefault();
        const _formData = new FormData();
        _formData.append('appt', appt_id);
        _formData.append('pat', invData.map(row => row.pat_id));
        _formData.append('itest_id', itest_id);
        if (resultFormData.it_files && resultFormData.it_files.length > 0) {
            for (let i = 0; i < resultFormData.it_files.length; i++) {
                _formData.append('invt_files', resultFormData.it_files[i]);
            }
        }
        _formData.append('remarks', remarks);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        axios.post(`${baseUrl}invt-files-create/`, _formData)
            .then(response => {
                Swal.fire({
                    title: 'Files Uploaded.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                setTimeout(() => {
                    window.location.href = '/inv-files-view/';
                }, 2000);
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed. Please try again later.',
                    'error'
                );
            });
    };
    return (
        <section>
            <form enctype="multipart/form-data">
                {invData.map((row, index) => (
                    <div className="table-responsive">
                        <div key={index}>
                            <table className="erp-table-modern">

                                <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                    <th style={{padding: '10px', textAlign: 'left'}}>
                                        PID: {row.pat_id}
                                    </th>
                                    <th style={{padding: '10px', textAlign: 'left'}}>
                                        Patient: {row.patient}
                                    </th>
                                    <th style={{padding: '10px', textAlign: 'left'}}>
                                        Consultant: Dr. {row.cons}
                                    </th>
                                </tr>
                                </thead>

                            </table>

                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                {row.inv_test.split(',').map((test, subIndex) => (
                                    <div key={`${index}-${subIndex}`} style={{
                                        margin: '10px',
                                        padding: '10px',
                                        border: '1px solid #ccc',
                                        borderRadius: '5px',
                                        width: '100%'
                                    }}>
                                        <div className="mb-3">
                                            <label htmlFor="title" className="form-label">Test Name</label>
                                            <div style={{textAlign: 'center', fontWeight: 'bold'}}>{test}</div>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="video" className="form-label">Images</label>
                                            <input
                                                type="file"
                                                multiple
                                                className="form-control"
                                                name="it_files"
                                                onChange={handleFileChange}
                                                id="it_files"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Select Template</label>
                                            <select
                                                name="selectedTemplate"
                                                value={selectedTemplate}
                                                onChange={handleTemplateChange}
                                                className="form-control"
                                            >
                                                <option>Select Template</option>
                                                {temp.map((template, idx) => (
                                                    <option key={idx} value={template.id}>
                                                        {template.type}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Report</label>
                                            <ReactQuill style={{height: "300px"}} value={remarks}
                                                        onChange={setRemarks}/>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-5">Submit</button>
                    </div>
                ))}
            </form>
        </section>
    );
}
export default InvResultEntry;
